module.exports = __webpack_public_path__ + "img/ba74ec6c-6542-4236-9996-b98ce74e1c86.e1010941.png";